import { PhoneOutlined } from "@ant-design/icons";
import { AiFillEdit } from "react-icons/ai";
import { FaWalking } from "react-icons/fa";
import React, { useState } from "react";
import { MdArchive, MdUnarchive } from "react-icons/md";
import { USER_PROFILE } from "@src/helpers/imagesConstants";
import SubjectsFormModal from "../subject-form-modal/SubjectFormModal";
import {
  AppDispatch,
  getMyOrganization,
  getParentHierarchyRequest,
  getSubject,
  getSubjectClear,
  getSubjectRequest,
  Subject } from
"@src/redux";
import { LuPhone } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import { useCheckPageComponentAccess } from "@src/hooks/index";
import { Tooltip } from "antd";

interface SubjectDetailsCardProps {
  subject: Subject;
}
var pluralize = require("pluralize");

const SubjectDetailsCard: React.FC<SubjectDetailsCardProps> = ({ subject }) => {
  const [mutationType, setMutationType] = useState<"edit" | "add">("edit");
  const dispatch = useDispatch<AppDispatch>();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const { result: myOrgResult } = useSelector(getMyOrganization);
  const [formType, setFormType] = useState<
    "subject_archive" |
    "transferSubject" |
    "edit_subject" |
    "subject_un_archive">(
    "edit_subject");

  const onClickToOpen = (
  type:
  "subject_archive" |
  "transferSubject" |
  "edit_subject" |
  "subject_un_archive") =>
  {
    if (type === "edit_subject") {
      dispatch(
        getParentHierarchyRequest({ id: subject?.organizationId || "" })
      );
      dispatch(getSubjectRequest({ filter: { id: subject?.id } }));
    } else if (type === "transferSubject") {
      dispatch(
        getParentHierarchyRequest({ id: subject?.organizationId || "" })
      );
    }
    setFormType(type);
    setModalVisible(true);
    setMutationType("edit");
    dispatch(getSubjectClear());
  };

  const onCancel = () => {
    setModalVisible(false);
  };

  const getModalTitle = (
  type:
  "subject_archive" |
  "transferSubject" |
  "edit_subject" |
  "subject_un_archive") =>
  {
    switch (type) {
      case "subject_archive":
        return `Archive ${subject?.name}`;
      case "subject_un_archive":
        return `Un Archive ${subject?.name}`;
      case "transferSubject":
        return `Transfer ${subject?.name}`;
      case "edit_subject":
        return `Edit ${pluralize.singular(
          myOrgResult?.rootOrganization?.subjectLabel || ""
        )}`;
      default:
        return "Edit";
    }
  };
  const sortedKeyValueList = [...(subject?.keyValueList || [])].sort(
    (a, b) =>
    Number(b?.organizationSubjectKey?.priorityOrder || 0) -
    Number(a?.organizationSubjectKey?.priorityOrder || 0)
  );

  const organizationKeyName =
  sortedKeyValueList?.[0]?.organizationSubjectKey?.name || null;
  const organizationKeyValue = sortedKeyValueList?.[0]?.value || null;


  return (
    <div>
      <div className={`subject-card-container ${subject?.isArchived ? "subject-card-archived" : ""}`}>
        <div className="subject-card-gradient-bar" />
        <div className="subject-card-header">
          <div className="subject-avatar-wrap">
            <img
              src={subject?.photo || USER_PROFILE}
              className="subject-avatar-img"
              alt="User Profile" />
          </div>
          <div className="subject-name">{subject?.name}</div>
          {organizationKeyName && organizationKeyValue && (
            <div className="subject-key-badge">
              {organizationKeyName}: {organizationKeyValue}
            </div>
          )}
        </div>
        <div className="subject-card-body">
          <div className="subject-phone">
            <LuPhone className="subject-phone-icon" />
            <span>
              {subject?.mobile?.number
                ? `+${subject?.mobile?.country_short_code} ${subject?.mobile?.number}`
                : "-"}
            </span>
          </div>
        </div>
        <div className="subject-card-footer">
          {subject?.isArchived &&
          useCheckPageComponentAccess("subject_archive_action") &&
          <Tooltip title={"Un Archive"}>
                <button className="subject-action-btn subject-action-green" onClick={() => onClickToOpen("subject_un_archive")}>
                  <MdUnarchive />
                </button>
              </Tooltip>}

          {!subject?.isArchived &&
          useCheckPageComponentAccess("subject_archive_action") &&
          <Tooltip title={"Archive"}>
                <button className="subject-action-btn subject-action-pink" onClick={() => onClickToOpen("subject_archive")}>
                  <MdArchive />
                </button>
              </Tooltip>}

          {useCheckPageComponentAccess("subject_transfer_action") &&
          <Tooltip title={"Transfer"}>
              <button className="subject-action-btn subject-action-purple" onClick={() => onClickToOpen("transferSubject")}>
                <FaWalking />
              </button>
            </Tooltip>}

          {useCheckPageComponentAccess("update_subject_action") &&
          <Tooltip title={"Edit"}>
              <button className="subject-action-btn subject-action-blue" onClick={() => onClickToOpen("edit_subject")}>
                <AiFillEdit />
              </button>
            </Tooltip>}
        </div>
      </div>
      <SubjectsFormModal
        subject={subject}
        visible={modalVisible}
        mutationType={mutationType}
        onCancel={onCancel}
        formType={formType}
        title={getModalTitle(formType)}
        setModalVisible={setModalVisible} />
      
    </div>);

};

export default SubjectDetailsCard;